import { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { Spin, Button, Modal, notification, Tooltip } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useHistory, useParams } from "react-router-dom";
import RestService from "../../../../api/RestService";
import {
  clearLessonPlayground,
  getPlaygroundContext,
  hasLessonPlaygroundData,
  updatePlaygroundLessonId,
} from "../../../LessonLabTeacher/playgroundStorage";

function PlaygroundLessons() {
  const history = useHistory();
  const { instructorId, id, classId } = useParams();
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [playgroundTick, setPlaygroundTick] = useState(0);
  const playgroundContext = getPlaygroundContext();

  useEffect(() => {
    document.body.classList.add("admin-nav");
    localStorage.setItem("selectedClassID", classId);
    localStorage.setItem("lessonID", JSON.stringify(parseInt(classId, 10)));
    setLoading(true);
    RestService.getLessonsByClassId(classId)
      .then((response) => {
        setData({
          status: response?.status,
          data: response?.data || [],
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [classId]);

  const goBack = () => {
    const homePath = playgroundContext.homePath
      || (instructorId ? `/Instructor/${instructorId}/Classes/${id}` : "/Teacher");
    history.push(homePath);
  };

  const clearLesson = (lesson) => {
    Modal.confirm({
      title: "Clear answers",
      content: `Clear your answers for "${lesson.heading}"? This only removes data stored on this device.`,
      okText: "Clear",
      okType: "danger",
      onOk: () => {
        clearLessonPlayground(classId, lesson.lessonId);
        setPlaygroundTick((value) => value + 1);
        notification.open({
          placement: "top",
          duration: 2,
          message: "Answers cleared",
        });
      },
    });
  };

  return (
    <div className="container">
      <div className="content">
        <Row className="py-3">
          <Col md="4">
            <Button icon={<ArrowLeftOutlined />} onClick={goBack} className="border-0" />
            Go Back
          </Col>
          <Col md="4" className="text-center">
            <h3 className="text-dark">
              {playgroundContext.className || "Choose your lesson"}
            </h3>
          </Col>
        </Row>
        <hr />
        <Spin tip="Loading..." spinning={loading} size="large">
          <Row key={playgroundTick}>
            {(data.data || []).map((lesson) => (
              <Col md="3" key={lesson.lessonId || lesson.id} className="mb-4">
                <Link
                  to={`/LessonLabTeacher/${lesson.engageStepId || 0}/${lesson.evaluateStepId || 0}/${lesson.explainStepId || 0}/${lesson.exploreStepId || 0}/${lesson.extendStepId || 0}`}
                  onClick={() => {
                    localStorage.setItem("selectedLessonID", lesson.lessonId);
                    localStorage.setItem("selectedClassID", classId);
                    updatePlaygroundLessonId(lesson.lessonId);
                  }}
                >
                  <div className="lesson-image score-hover">
                    <img src={lesson.image} alt={lesson.heading} height="1000px" className="imageLessonStyle" />
                    <div className="overlay">
                      <p className="g-card-top">Introductory</p>
                      <p className="g-card-title">{lesson.heading}</p>
                    </div>
                  </div>
                </Link>
                <div className="text-center mt-2">
                  <Tooltip
                    title={hasLessonPlaygroundData(classId, lesson.lessonId)
                      ? "Clears your response"
                      : "Fill in answers first to enable Clear"}
                  >
                    <span>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        style={{ padding: "4px 16px", borderRadius: 1 }}
                        disabled={!hasLessonPlaygroundData(classId, lesson.lessonId)}
                        onClick={() => clearLesson(lesson)}
                      >
                        Clear
                      </button>
                    </span>
                  </Tooltip>
                </div>
              </Col>
            ))}
          </Row>
        </Spin>
      </div>
    </div>
  );
}

export default PlaygroundLessons;
